import React, { useCallback, useEffect, useMemo, useState } from "react";
import CloseIcon from "@material-ui/icons/Close";
import { Button, Form, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import "./styles.scss";
import { BsFilter } from "react-icons/bs";
import { AiOutlineClose, AiOutlineSearch } from "react-icons/ai";
import moment from "moment";
import DataTable from "react-data-table-component";

import { attachmentImport, getAttachments, getAttachmentTypes } from "services/NexiDigitalAPI";
import { toast, ToastContainer } from "react-toastify";
import Loading from "components/Loading";
import PreloaderBlur from "containers/PeopleCraft/PreloaderBlur";

const paginationComponentOptions = {
  rowsPerPageText: "Arquivos por página",
  rangeSeparatorText: "de",
};


const customTableStyles = {
  table: {
    style: {
      maxHeight: "70vh",
      overflow: "auto",
    },
  },
  headCells: {
    style: {
      backgroundColor: "#6b48ff",
      color: "white",
      paddingLeft: "30px",
    },
  },
  cells: {
    style: {
      paddingLeft: "30px",
    },
  },
};

export const ImportFiles = ({onClose, id, updateListAttachment}) => {
  const [formState, setFormState] = useState({
    searchText: "",
    idAttachmentType: null,
    onlyMine: false,
  });
  const [activeFilter, setActiveFilter] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingAction, setLoadingAction] = useState(false);
  const [listFormatFile, setListFormatFile] = useState([]);
  const [filesList, setFilesList] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const handleChange = (field, value) => {
    setFormState((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  };

  const handleAttachmentImport = useCallback(async (idAttachment) => {
    setLoadingAction(true)
    try {

      await attachmentImport(idAttachment, id);
      onClose(true)
      toast.success(`Arquivo importado com sucesso`);
    } catch (e) {
      toast.error(`Error ao tentar importar aquivo`);
    } finally {
      setLoadingAction(false)
    }
  }, [id, onClose])

  const columns = useMemo( () => [
    {
      name: "Nome do arquivo",
      selector: "title",
      sortable: false,
      width: '400px',
      cell: (currentFile) => [
          <OverlayTrigger
            placement={"top"}
            overlay={<Tooltip id={`tooltip-top`}> {currentFile.title} </Tooltip>}
          >
            <span className="ellipsis-text">{currentFile.title}</span>
          </OverlayTrigger>
      ]
    },
    {
      name: "Data de criação",
      sortable: false,
      selector: "creationDate",
      cell: (data, index) => (
          <span key={index}>{data.creationDate ? moment(data.creationDate).format("DD/MM/YYYY") : ""}</span>
      ),
    },
    {
      name: "Formato",
      selector: "format",
      sortable: false,
      center: true,

    },
    {
      name: "Criador por",
      selector: "creatorName",
      sortable: false,

    },
    {
      name: "Ações",
      selector: "action",
      center: true,
      cell: (currentFile) => [
        <div key={currentFile.idAttachment} className="listBtn">
          <OverlayTrigger
            placement={"top"}
            overlay={<Tooltip id={`tooltip-top`}> Importar </Tooltip>}
          >
            <button
              type="button"
              onClick={() => {
                handleAttachmentImport(currentFile.idAttachment)
              }}
              className="btn content-page-button"
              style={{
                backgroundColor: "#feac0e",
                margin: "0 auto",
                whiteSpace: "nowrap",
                height: 30,
              }}
            >
              Importar
            </button>
          </OverlayTrigger>
        </div>,
      ],
    },
  ], [handleAttachmentImport]);

  const getListFormats = useCallback(async () => {
    setLoading(true)
    try {
      const result = await getAttachmentTypes( );
      setListFormatFile(result.data?.types || [])
    } catch (e) {
      setListFormatFile([]);
    } finally {

    }
  }, [])

  const fetchData = useCallback(async (offset, limit, filter?) => {
    setLoading(true)
    try {
      const params = {
        notInTeam: true,
        ...filter,
        offset,
        limit
      }
      const result = await getAttachments(id, params);
      setFilesList(result.data?.result || []);
      setTotalRows(result.data?.totalRecords);
    } catch (e) {
      setListFormatFile([]);
    } finally {
      setLoading(false)
    }

  }, [id]);



  const handlePageChange = (page) => {
    const newOffset = (page - 1) * perPage;
    fetchData(newOffset, perPage);
  };
  const handlePerRowsChange = async (newPerPage, page) => {
    setPerPage(newPerPage);

  };

  const removeEmptyValues = (obj: Record<string, any>) => {
    return Object.fromEntries(
      Object.entries(obj).filter(([_, value]) => !!value)
    );
  };


  const handleFilter = () => {
    const values = removeEmptyValues(formState)
    setActiveFilter(!!Object.keys(values).length)
    fetchData(0, perPage,values)
  }

  useEffect(() => {
    fetchData(0, perPage);
  }, [perPage]);

  useEffect(() => {
    getListFormats();
  }, [getListFormats]);



  const EmptyAttaches = () => {
    return (
      <div className="class-attachment-empty-container">
        <div className="class-attachment-empty-header">
          <span className="class-attachment-empty-container-title">
            Ainda não há arquivos cadastrado.
          </span>
          <span className="class-attachment-empty-container-description">
            Comece cadastrando um arquivo
          </span>
        </div>
      </div>
    );
  };

  const FilterEmpty = () => {
    return (
      <div className="class-attachment-empty-container">
        <div className="class-attachment-empty-header">
          <span className="class-attachment-empty-container-title">
            Não foram encontrados resultados!
          </span>
        </div>
      </div>
    );
  };

  return (

    <div className="modal-import-files" style={{ minHeight: 400 }}>
        {loadingAction &&   <PreloaderBlur /> }
      <Modal.Title className="modal-title">
        <h5>Banco de arquivos</h5>
        <div className="box-icon" onClick={onClose}>
          <CloseIcon style={{ color: "#8D9299" }} className="modal-warning-close" />
        </div>
      </Modal.Title>
      <Modal.Body>
        <div className="filtersOptions">
          <div className="div-box-input">
            <div className="searchInfo">
              <AiOutlineSearch />
              <Form.Control
                id="searchInput"
                value={formState.searchText}
                onChange={(e) => handleChange("searchText", e.target.value)}
                placeholder={`Procurar por nome do arquivo`}
              />
              {formState.searchText && (
                <button className="cleanSearch" onClick={() => handleChange("searchText", "")}>
                  <AiOutlineClose />
                </button>
              )}
            </div>
            <Form.Group>
              <Form.Check
                type="checkbox"
                label="Listar apenas arquivo cadastrados por mim"
                checked={formState.onlyMine}
                onChange={(e) =>  handleChange("onlyMine", e.target.checked)}
              />
            </Form.Group>
          </div>

          <div>
            <Form.Control
              as="select"
              value={formState.idAttachmentType}
              onChange={(e) => {
                handleChange("idAttachmentType", e.target.value);
              }}
            >
              {listFormatFile.length > 0 ? (
                <>
                  <option value="">Todos os formatos</option>
                  {listFormatFile?.map((format, index) => (
                    <option key={`format-${index}`} value={format.idAttachmentType}>
                      {format.name}
                    </option>
                  ))}
                </>
              ) : (
                <option value={0}>Carregando...</option>
              )}
            </Form.Control>
          </div>

          <Button
            className="buttonSearch color"
            variant="primary"
            onClick={handleFilter}
          >
            <BsFilter />
            <span>Filtrar</span>
          </Button>
        </div>
        <div style={{padding: 10}}>
             <DataTable
             columns={columns}
             customStyles={customTableStyles}
             data={filesList}
             progressComponent={
               <Loading containerStyle={{ height: 400 }}>Buscando termos...</Loading>
             }
             noDataComponent={
              <div className="class-attachment-content">
                <div className="content-page-card">
                  {totalRows === 0 && !activeFilter ? <EmptyAttaches /> : <FilterEmpty />}
                </div>
              </div>
            }
             onChangePage={handlePageChange}
             onChangeRowsPerPage={handlePerRowsChange}
             paginationTotalRows={totalRows}
             progressPending={loading}
             paginationComponentOptions={paginationComponentOptions}
             paginationServer
             pagination
             noHeader
             fixedHeader

           />
        </div>
      </Modal.Body>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};
